"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteUploadResponseDtoMediaTypeEnum = void 0;
exports.instanceOfCompleteUploadResponseDto = instanceOfCompleteUploadResponseDto;
exports.CompleteUploadResponseDtoFromJSON = CompleteUploadResponseDtoFromJSON;
exports.CompleteUploadResponseDtoFromJSONTyped = CompleteUploadResponseDtoFromJSONTyped;
exports.CompleteUploadResponseDtoToJSON = CompleteUploadResponseDtoToJSON;
exports.CompleteUploadResponseDtoToJSONTyped = CompleteUploadResponseDtoToJSONTyped;
/**
 * @export
 */
exports.CompleteUploadResponseDtoMediaTypeEnum = {
    Image: 'IMAGE',
    Video: 'VIDEO',
    Audio: 'AUDIO',
    Document: 'DOCUMENT',
    Thumbnail: 'THUMBNAIL',
    Other: 'OTHER'
};
/**
 * Check if a given object implements the CompleteUploadResponseDto interface.
 */
function instanceOfCompleteUploadResponseDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('mediaType' in value) || value['mediaType'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('fileSizeBytes' in value) || value['fileSizeBytes'] === undefined)
        return false;
    if (!('isProcessed' in value) || value['isProcessed'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function CompleteUploadResponseDtoFromJSON(json) {
    return CompleteUploadResponseDtoFromJSONTyped(json, false);
}
function CompleteUploadResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'url': json['url'],
        'mediaType': json['mediaType'],
        'mimeType': json['mimeType'],
        'fileSizeBytes': json['fileSizeBytes'],
        'isProcessed': json['isProcessed'],
        'createdAt': json['createdAt'],
    };
}
function CompleteUploadResponseDtoToJSON(json) {
    return CompleteUploadResponseDtoToJSONTyped(json, false);
}
function CompleteUploadResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'url': value['url'],
        'mediaType': value['mediaType'],
        'mimeType': value['mimeType'],
        'fileSizeBytes': value['fileSizeBytes'],
        'isProcessed': value['isProcessed'],
        'createdAt': value['createdAt'],
    };
}
